import TomSelect from "tom-select";

const fn = {
    init: () => {
        const countyInput = document.querySelector('#county'); // county TomSelect

        // Initialize county TomSelect
        fn.setupSelectSearch(countyInput);
    },

    setupSelectSearch: (searchSelector) => {
        if (!searchSelector) {
            return;
        }

        const tsWrapper = '.ts-wrapper.search-county .ts-control';

        const dataElement = document.getElementById('counties');
        if (!dataElement) return;

        const dataJSON = dataElement.getAttribute('data-json');
        const data = JSON.parse(dataJSON.replace(/&quot;/g, '"').replace(/&#039;/g, "'"));

        const selectedItems = dataElement.getAttribute('data-selected-items');
        const selectedItemsArray = selectedItems ? selectedItems.split(',') : [];

        let options = [];
        for (let key in data) {
            options.push({
                value: key,
                text: data[key]
            });
        }
        const tomselect = new TomSelect(searchSelector, {
            maxItems: null,
            maxOptions: null,
            options: options,
            selectOnTab: true,
            create: false,
            plugins: {
                'clear_button':{
                    'title':'Remove all selected options',
                    'html':function(data) {
                        return `<div class="${data.className}" title="${data.title}"><svg width="15" height="15" viewBox="0 0 15 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M0.156 14.843a0.537 0.537 0 0 0 0.758 0l6.585 -6.584 6.587 6.584a0.537 0.537 0 0 0 0.758 -0.758L8.256 7.501l6.584 -6.586a0.537 0.537 0 0 0 -0.758 -0.758L7.498 6.743 0.911 0.16a0.536 0.536 0 0 0 -0.755 0.755l6.585 6.586 -6.585 6.588a0.537 0.537 0 0 0 0 0.755" fill="currentColor"/></svg></div>`;
                    },
                },
                'remove_button':{
                    'title':'Remove this option',
                },
                'no_active_items':{},
            },
            onItemAdd: function() {
                fn.scrollToRight(tsWrapper);
            },
            items: selectedItemsArray,
        });
        searchSelector.setAttribute('aria-hidden', 'true');
        return tomselect;
    },

    scrollToRight: (tsWrapper) => {

        let searchInputField = document.querySelector(tsWrapper);
        searchInputField.scrollLeft = searchInputField.scrollWidth;

        if (window.innerWidth <= 767) {
            //let mobileSearchInputField = document.querySelector('.mobileSearch .ts-control');
            //mobileSearchInputField.scrollLeft = mobileSearchInputField.scrollWidth;
        }
    }
}

export default {
    can: () => document.querySelectorAll('.search-county').length > 0,
    run: fn.init,
}
